export default {
    scroll: function (el, duration, callback, context) {
        duration = duration || 500;
        context = context || window;

        const requestAnimationFrame = window.requestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            function (fn) {
                window.setTimeout(fn, 15);
            };

        let clock = Date.now();
        let start = context.scrollTop || window.pageYOffset;
        let end = 0;

        if (typeof el === 'number') {
            end = parseInt(el, 10);
        } else {
            end = this._getOffsetTop(el, start);
        }

        let step = () => {
            let elapsed = Date.now() - clock;

            if (context === window) {
                window.scroll(0, this._getScrollTop(start, end, elapsed, duration));
            } else {
                context.scrollTop = this._getScrollTop(start, end, elapsed, duration);
            }

            if (elapsed > duration) {
                if (typeof callback === 'function') {
                    callback(el);
                }
            } else {
                requestAnimationFrame(step);
            }
        };

        step();
    },

    _getOffsetTop: function (element, start) {
        if (element.nodeName === 'HTML') {
            return -start;
        }

        return element.getBoundingClientRect().top + start;
    },

    _getScrollTop: function (start, end, elapsed, duration) {
        if (elapsed > duration) {
            return end;
        }

        return start + ((end - start) * this._easeInOutCubic(elapsed / duration));
    },

    _easeInOutCubic: function (t) {
        return (t < 0.5) ? (4 * t * t * t) :
            ((t - 1) * ((2 * t) - 2) * ((2 * t) - 2)) + 1;
    }
};



// WEBPACK FOOTER //
// ./src/assets/js/SmoothScroll.js